import { Helmet } from "react-helmet-async";

/** Global site-wide schemas — Organization, WebSite (with SearchAction),
 * SoftwareApplication. Mounted once in App.js so every page inherits them. */
const BASE = "https://venturekhoj.com";

export default function GlobalSchemas() {
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "VentureKhoj™",
    url: BASE,
    logo: `${BASE}/brand/vk-favicon.svg`,
    description:
      "AI-powered business feasibility & match platform for Indian entrepreneurs.",
    sameAs: [],
  };
  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "VentureKhoj™",
    url: BASE,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${BASE}/business-ideas?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };
  const app = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "VentureKhoj™",
    url: BASE,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    offers: { "@type": "Offer", price: "0", priceCurrency: "INR" },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "1240",
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(org)}</script>
      <script type="application/ld+json">{JSON.stringify(website)}</script>
      <script type="application/ld+json">{JSON.stringify(app)}</script>
    </Helmet>
  );
}
